module.exports = __webpack_public_path__ + "unicef.svg?2480d3e4d7c18592558502103c093337";